import React, { useEffect} from 'react';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Box from '@mui/joy/Box';

interface CircularProgressCountUpProps {
  isLoadingExcel: boolean;
  onReset: () => void;
  setProgress: React.Dispatch<React.SetStateAction<number>>;
  progress: number;
}

const HorizontalProgressBar: React.FC<CircularProgressCountUpProps> = ({
  isLoadingExcel,
  onReset,
  progress,
  setProgress
}) => {


  useEffect(() => {
    if (isLoadingExcel) {

      const interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 90 && prevProgress < 99) {
            return 90;
          }
          if (prevProgress >= 100) {
            clearInterval(interval);
            setTimeout(onReset, 500);  
            return 100;
          }
          return prevProgress + 1;  
        });
      }, 15); 
      return () => clearInterval(interval);
    }
  }, [isLoadingExcel, onReset]);

  if (!isLoadingExcel) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
        backdropFilter: 'blur(2px)',
        backgroundColor: 'rgba(137, 137, 137, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Box
          sx={{
            width: '400px',
            backgroundColor: '#e0e0e0',
            borderRadius: '8px',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: `${progress}%`,
              height: '20px',
              backgroundColor: '#1D96D2',
              transition: 'width 0.3s ease-in-out',
              fontWeight: 'bold',
            }}
          />
        </Box>
        <Typography fontSize="xl" fontWeight="bold">
          {progress}% - Waiting for downloading all Excel data...
        </Typography>
      </Stack>
    </Box>
  );
};

export default HorizontalProgressBar;
